import React from 'react'
import { Receipt, LinkedReceipt } from 'src/services/receipts'
import { ReceiptListItem } from './receipt-list-item'
import type { ViewMode } from 'src/hooks/use-view-mode'

interface ReceiptListItemActionWrapperProps {
  receipt: Receipt | LinkedReceipt
  actions: React.ReactNode
  className?: string
  viewMode?: ViewMode
  /** List view only: metadata under the receipt name. */
  meta?: React.ReactNode
}

export const ReceiptListItemActionWrapper: React.FC<ReceiptListItemActionWrapperProps> = ({
  receipt,
  actions,
  className,
  viewMode = 'card',
  meta,
}) => {
  if (viewMode === 'list') {
    // List rows lay actions out inline on the right instead of overlaying them.
    return <ReceiptListItem receipt={receipt} viewMode="list" meta={meta} actions={actions} />
  }

  return (
    <div className="relative">
      <ReceiptListItem receipt={receipt} />
      <div
        className={`absolute bottom-2 right-2 flex flex-wrap justify-end gap-1 sm:gap-2 ${className}`}
      >
        {actions}
      </div>
    </div>
  )
}
